import React, { useEffect, useState, useRef, useCallback } from "react";
import {Button, useNotify, useRedirect} from "react-admin";
import { useNavigate } from "react-router-dom";
import {httpCreate, httpGet} from "../../../Api/api";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

import "./style.css";
import CircularProgress from "@mui/material/CircularProgress";

export const ChatPage = () => {
  const sendButtonRef = useRef(null)
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState("");
  const [chatId, setChatId] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [sendButtonWidth, setSendButtonWidth] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const questionsEndRef = useRef(null);
  const navigate = useNavigate();
  const notify = useNotify();

  useEffect(() => {
    if (sendButtonRef?.current) {
      setSendButtonWidth(sendButtonRef.current?.offsetWidth + 20)
    }
  }, [sendButtonRef?.current])

  const handleClickVariant = (message, variant) => {
   // enqueueSnackbar(message, { variant });
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      if (questionsEndRef.current) {
        questionsEndRef.current.scrollTo({
          top: questionsEndRef.current.scrollHeight + 500,
          behavior: "smooth",
        });
      }
    }, 500);
  };
  

  const handleGetQuestions = useCallback(async () => {
    try {
      httpGet('ai/questions/chat').then((data) => {
          setQuestions(data.data.items)
          setNewQuestion("");
          setIsLoading(false);
          scrollToBottom();
      });

    } catch (error) {
      if (error?.response?.status === 401) {
        return;
      }

      handleClickVariant(error.message, "error");
    }
  }, [chatId]);


  const handleSendMessage = async () => {
    if (!newQuestion.trim()) return;

    if (newQuestion?.length > 4096) {
      handleClickVariant('Max message length is 4096', 'error')
      return
    }

    try {
      setIsLoading(true);
      httpCreate('ai/questions', {'name' : newQuestion}).then(({status, statusText, headers, body}) => {
          console.log(newQuestion);
          setNewQuestion("");
          setIsLoading(false);
          handleGetQuestions();
          scrollToBottom();
      }).catch(error => {
          console.log(error);
          notify(error.message, {type: 'error'});
          setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      console.error("Error sending message:", error);
      handleClickVariant(error.message, "error");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const backToStatistic = async () => {
    navigate(`/ai/questions`)
  };

  useEffect(() => {
    scrollToBottom();
  }, [isInitialLoad]);

  useEffect(() => {
    if (questions.length === 0) {
        handleGetQuestions();
    }
  }, [handleGetQuestions]);


  return (
    <>
      <div>
        <span
          className="back-button"
          onClick={backToStatistic}
        >
          <img
            src={process.env.PUBLIC_URL + "/back-arrow.svg"}
            alt="back-arrow"
            style={{ width: 20, height: 20 }}
          />
          Back to Statistic
        </span>
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            height: "calc(-250px + 100dvh)",
            overflowY: "scroll",
          }}
          ref={questionsEndRef}
        >
          {questions.length > 0 ? (
            questions.map((quest, index) => {
              return (<div>
                  <div key={index} style={{display: "flex"}}>
                      <div
                          style={{
                              marginLeft: "auto",
                              display: "inline-block",
                              backgroundColor: "#f1f1f1",
                              padding: "8px",
                              borderRadius: "8px",
                              maxWidth: "100%",
                              marginTop: "10px",
                              marginBottom: "10px",
                              wordBreak: "break-word"
                          }}
                      >
                          <div>
                              <strong>Question:</strong>
                              <div style={{display: "flex", alignItems: "flex-start"}}>{quest.name}</div>
                          </div>
                      </div>
                  </div>
                  <div key={index}>
                    <div
                        style={{
                            display: "inline-block",
                            backgroundColor: "#d0e7ff",
                            padding: "8px",
                            borderRadius: "8px",
                            maxWidth: "100%",
                            wordBreak: "break-word"
                        }}
                    >
                        <strong>Answer:</strong>
                        <div style={{
                            display: "flex",
                            alignItems: "flex-start"
                        }}>
                            <ReactMarkdown className="markdown-container" children={quest.answer} remarkPlugins={[remarkGfm]} />
                        </div>
                    </div>
                  </div>
                  </div>
              );
            })
          ) : (
            <p style={{textAlign: "center", color: 'rgba(0, 0, 0, 0.54)', display: "inline-block", width: "100%"}}>{"You don`t have questions yet"}</p>
          )}
        </div>

        {
            <div className="wrapper-send">
                {isLoading ?
                    <div style={{textAlign: "center"}} >
                        <CircularProgress color="inherit"  />
                    </div>
                    :
                    <div className="textarea-block">
                        <textarea
                            value={newQuestion}
                            onChange={(e) => setNewQuestion(e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Ask me anything about DARE..."
                            className="textarea"
                        />
                        <div style={{left: 'unset', right: `${sendButtonWidth + 10}px`}} className="voice-recorder-wrap"></div>
                        <div ref={sendButtonRef} className="send-button-wrap">
                            <Button
                                variant="contained"
                                className="button-send"
                                onClick={handleSendMessage}
                            >
                                <img src={`${process.env.PUBLIC_URL}/send.svg`} alt="Upload"/>
                            </Button>
                        </div>
                    </div>
                }
            </div>
        }
      </div>
    </>
  );
};
